<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">並び順の設定</span>
        </div>
        <div class="popup-content">
          <div v-if="isSearch" class="formparts radio">
            <input type="radio" value="score" id="knowledge_search_order_setting_01" v-model="radioModel">
            <label role="button" for="knowledge_search_order_setting_01">関連度順</label>
          </div>
          <div class="formparts radio">
            <input type="radio" value="created_desc" id="knowledge_search_order_setting_02" v-model="radioModel">
            <label role="button" for="knowledge_search_order_setting_02">作成日（新しい順）</label>
          </div>
          <div class="formparts radio">
            <input type="radio" value="created_asc" id="knowledge_search_order_setting_03" v-model="radioModel">
            <label role="button" for="knowledge_search_order_setting_03">作成日（古い順）</label>
          </div>
          <div class="button mt32">
            <button class="btn" @click="submit">設定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { KnowledgeSearchOrderSetting } from '@/logic/knowledge/KnowledgeSearchOrderSetting'

export default defineComponent({
  setup (props, context) {
    return { ...KnowledgeSearchOrderSetting(props, context) }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
